import React, {Component} from 'react';
import logo from './images/logo_dashbo_white.svg';
import {Link} from "react-router-dom";
import {FaIcon} from "./components/FaIcon";

export class CrmLayoutBar extends Component {
    render() {
        return (
            <header className="crm-layout-bar">
                <Link to={`/${this.props.crmFrontPath}`}>
                    <img src={logo} className="crm-logo" alt="logo"/>
                </Link>
                <Link className="sidebar-main-link" to={`/${this.props.crmFrontPath}/config`}><FaIcon iconName="cogs"/></Link>
            </header>
        );
    }
} 